import {Easing, Group, Tween} from "@tweenjs/tween.js";
import ObstacleManager from "./ObstacleManager";
import common from "../common";

export default class PlayerCharacter extends PIXI.Container {

    get speed() {
        return this._speed;
    }

    get collider() {
        return this._collider;
    }

    get headCollider() {
        return this._headCollider;
    }

    constructor() {
        super();

        this._tweens = new Group();

        this._speed = 720;

        /*
        this._view = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._view.anchor.set(0.5, 1);
        this._view.width = 120;
        this._view.height = 340;
        this.addChild(this._view);

         */

        this._pivotBar = new PIXI.Container();
        this.addChild(this._pivotBar);

        this._pivotPointA = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._pivotPointA.anchor.set(0.5);
        this._pivotPointA.position.set(-20, -20);
        this._pivotPointA.renderable = false;
        this._pivotBar.addChild(this._pivotPointA);

        this._pivotPointB = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._pivotPointB.anchor.set(0.5);
        this._pivotPointB.position.set(20, 20);
        this._pivotPointB.renderable = false;
        this._pivotBar.addChild(this._pivotPointB);

        this._shaggy = new PIXI.spine.Spine(P3.assets.spineData("shaggy"));
        this._shaggy.autoUpdate = false;
        this._shaggy.skeleton.setSkinByName("regular");
        this._shaggy.state.setAnimation(0, "idle_generic", true);
        this._shaggy.update(0);
        this.addChild(this._shaggy);

        this._scooby = new PIXI.spine.Spine(P3.assets.spineData("scooby"));
        this._scooby.autoUpdate = false;
        this._scooby.skeleton.setSkinByName("regular");
        this._scooby.state.setAnimation(0, "idle_generic", true);
        this._scooby.update(0);
        this.addChild(this._scooby);

        this._headCollider = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._headCollider.tint = 0xff0000;
        this._headCollider.anchor.set(0.5, 1);
        this._headCollider.width = 20;
        this._headCollider.height = 140;
        this._headCollider.x = 100;
        this._headCollider.y = -100;
        this._headCollider.renderable = false;
        this.addChild(this._headCollider);

        this._collider = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._collider.tint = 0xff0000;
        this._collider.anchor.set(0.5, 1);
        this._collider.width = 20;
        this._collider.height = 30;
        this._collider.renderable = false;
        this.addChild(this._collider);

        const localA = this.toLocal(this._pivotPointA, this._pivotBar);
        this._shaggy.position = localA;

        const localB = this.toLocal(this._pivotPointB, this._pivotBar);
        this._scooby.position = localB;

        this._stopped = true;

        this._scoobySkinTypes = [];
        this._shaggySkinTypes = [];

        this._scoobyUsesSkins = [
            ObstacleManager.TYPE.PAINT,
            ObstacleManager.TYPE.SLIME,
            ObstacleManager.TYPE.SPIDER_FLOOR
        ];

        this._shaggyUsesSkins = [
            ObstacleManager.TYPE.PAINT,
            ObstacleManager.TYPE.SLIME,
            ObstacleManager.TYPE.SPIDER_FLOOR,
            ObstacleManager.TYPE.SPIDER_STRING_A,
            ObstacleManager.TYPE.SPIDER_STRING_B,
            ObstacleManager.TYPE.BATS,
            ObstacleManager.TYPE.HAND
        ];

    }

    destroy(options) {

        common.skins = [];
        common.shaggySkins = [];
        common.scoobySkins = [];
        for (let i = 0; i < this._shaggySkinTypes.length; i++) {
            common.shaggySkins.push(this._shaggySkinTypes[i]);// clone
            if (common.skins.indexOf(this._shaggySkinTypes[i]) === -1)
                common.skins.push(this._shaggySkinTypes[i]);
        }
        for (let i = 0; i < this._scoobySkinTypes.length; i++) {
            common.scoobySkins.push(this._scoobySkinTypes[i]);// clone
            if (common.skins.indexOf(this._scoobySkinTypes[i]) === -1)
                common.skins.push(this._scoobySkinTypes[i]);
        }

        super.destroy(options);
    }

    update(dt) {
        this._tweens.update();

        this._shaggy.update(dt);
        this._scooby.update(dt);

        if (!this._stopped) {
            const torque = 0.8;
            this._pivotBar.rotation += torque * dt;

            const localA = this.toLocal(this._pivotPointA, this._pivotBar);
            this._shaggy.position = localA;

            const localB = this.toLocal(this._pivotPointB, this._pivotBar);
            this._scooby.position = localB;

            // basic depth sort
            if (this._shaggy.y < this._scooby.y) {
                this.addChild(this._scooby);
            } else {
                this.addChild(this._shaggy);
            }
        }
    }

    hit(type) {

        if (this._shaggyUsesSkins.indexOf(type) !== -1 && this._shaggySkinTypes.indexOf(type) === -1) {
            this._shaggySkinTypes.push(type);

            const spine = this._shaggy;

            // create new empty skin
            const newSkin = new PIXI.spine.core.Skin("combined-skin");
            // add base skin
            newSkin.addSkin(spine.spineData.findSkin("regular"));

            this.addSkins(this._shaggySkinTypes, spine, newSkin);
            spine.skeleton.setSkin(newSkin);

            //Reset slots to remove not used attachments
            spine.skeleton.setSlotsToSetupPose();
        } else if (this._scoobyUsesSkins.indexOf(type) !== -1 && this._scoobySkinTypes.indexOf(type) === -1) {
            this._scoobySkinTypes.push(type);

            const spine = this._scooby;

            // create new empty skin
            const newSkin = new PIXI.spine.core.Skin("combined-skin");
            // add base skin
            newSkin.addSkin(spine.spineData.findSkin("regular"));

            this.addSkins(this._scoobySkinTypes, spine, newSkin)
            spine.skeleton.setSkin(newSkin);

            //Reset slots to remove not used attachments
            spine.skeleton.setSlotsToSetupPose();
        }

    }

    addSkins(skins, spine, newSkin) {
        for (let i = 0; i < skins.length; i++) {
            // add extra skins to base skin
            switch (skins[i]) {
                case ObstacleManager.TYPE.PAINT: {
                    newSkin.addSkin(spine.spineData.findSkin("pickup_bucket"));
                    break;
                }
                case ObstacleManager.TYPE.SLIME: {
                    newSkin.addSkin(spine.spineData.findSkin("pickup_slime"));
                    break;
                }
                case ObstacleManager.TYPE.SPIDER_FLOOR: {
                    newSkin.addSkin(spine.spineData.findSkin("pickup_web"));
                    break;
                }
                case ObstacleManager.TYPE.SPIDER_STRING_A: {
                    newSkin.addSkin(spine.spineData.findSkin("pickup_spider2"));
                    break;
                }
                case ObstacleManager.TYPE.SPIDER_STRING_B : {
                    newSkin.addSkin(spine.spineData.findSkin("pickup_spider"));
                    break;
                }
                case ObstacleManager.TYPE.BATS : {
                    newSkin.addSkin(spine.spineData.findSkin("pickup_bat"));
                    if (!this._batSFX)
                        this._batSFX = P3.audio.playSound("sfx_bats_loop_00", {loop: true})
                    break;
                }
                case ObstacleManager.TYPE.HAND : {
                    newSkin.addSkin(spine.spineData.findSkin("pickup_hand"));
                    break;
                }
            }
        }
    }

    openJump() {
        this._scooby.state.setAnimation(0, "open_coffin_to_run", false);
        this._shaggy.state.setAnimation(0, "open_coffin_to_run", false);
    }

    revealShake() {
        this._scooby.state.setAnimation(0, "reveal_shake", true);
        this._shaggy.state.setAnimation(0, "reveal_shake", true);
    }

    intro(callback) {
        // this._scooby.state.setAnimation(0, "idle_to_run", false);
        this._scooby.state.setAnimation(0, "run_on_place", true);

        //  this._shaggy.state.setAnimation(0, "idle_to_run", true);
        this._shaggy.state.setAnimation(0, "run_in_place", true);

        P3.utils.delayg(this._tweens, 2, () => {
            // this.run();
            callback && callback.call();
        });
    }

    start() {
        this._tweenA = new Tween(this._pivotPointA, this._tweens)
            .to({x: this._pivotPointA.x - 40}, 1160)
            .easing(Easing.Quadratic.InOut)
            .yoyo(true)
            .repeat(Infinity)
            .start();

        this._tweenB = new Tween(this._pivotPointB, this._tweens)
            .to({x: this._pivotPointB.x + 40}, 1460)
            .easing(Easing.Quadratic.InOut)
            .yoyo(true)
            .repeat(Infinity)
            .start();

        this._stopped = false;
    }

    stop() {
        this._tweenA && this._tweenA.stop();
        this._tweenB && this._tweenB.stop();

        //this._shaggy.state.setAnimation(0, "idle", true);
        //this._scooby.state.setAnimation(0, "idle", true);

        this._stopped = true;
        this._runningLoop && this._runningLoop.stop();

        this._batSFX && this._batSFX.stop();

    }

    run() {
        this._runningLoop = P3.audio.playSound("sfx_running_steps_loop_00", {loop: true});
        this._shaggy.state.setAnimation(0, "running", true);
        this._scooby.state.setAnimation(0, "run", true);
    }

    trapped() {
        this._runningLoop && this._runningLoop.stop();
        this._scooby.state.setAnimation(0, "trapped", true);
        this._shaggy.state.setAnimation(0, "trapped", true);
    }

}